import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../api/api';
import '../styles/ResetPassword.css';

export default function ResetPassword() {
  const [search] = useSearchParams();
  const token = search.get('token');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await resetPassword({ token, password });
      alert('Password reset! Please log in.');
      navigate('/login');
    } catch {
      alert('Reset failed.');
    }
  };

  return (
    <div className="rp-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>
      </form>
    </div>
  );
}